
import React, { useState, useEffect, useContext } from "react";
import { contentContext } from "../context/contentContext";


const UploadPopup = () => {
    const { isUploading } = useContext(contentContext);


    if (!isUploading) return null;

    return (

        <>
            <div style={{
                position: 'fixed',
                top: '20%',
                right: 20,
                padding: '10px 20px',
                backgroundColor: '#333',
                color: '#fff',
                borderRadius: 5,
                zIndex: 1000,
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)'
            }}>
                File is uploading...
            </div>
        </>
    );
};


export default UploadPopup;



